/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Select, { components } from 'react-select'
import CreatableSelect from 'react-select/creatable';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { AppContext } from '../context/AppContext';
import Swal from 'sweetalert2'
import validationErrorMsg from '../helpers/ValidationErrorMsg'

interface FormData {
    expenseAmount: string;
    taAmount: string;
    daAmount: string;
    otherAmount: string;
    expenseDate: string;
    expenseCategory: string;
    idUsers: string;
    idApprover: string;
    idProjects: string;
    transactionType: string;
    idBankCash: string;
    idAccLedgers: string;
    remarks: string;
    status?: string;
}

interface ExpenseCreateProps {
    show: boolean;
    handleClose: (show: boolean) => void;
    id: number;
    actionChannel: string;
}

// approved
// requested
const ExpenseCreate: React.FC<ExpenseCreateProps> = ({ show, handleClose, id, actionChannel }) => {
    const { currentUser } = useContext(AppContext);
    // console.log(currentUser, "currentUser")
    const [isSubmitDisable] = useState(false);
    const [loading, setLoading] = useState(false);

    const [expenseCategories, setExpenseCategories] = useState([]);
    const [expenseCategory, setExpenseCategory] = useState(null);

    const [users, setUsers] = useState([]);
    const [user, setUser] = useState({ label: 'Select Sales Representative', value: '' });

    // eslint-disable-next-line
    const [approvers, setApprovers] = useState([]);
    // eslint-disable-next-line
    const [approver, setApprover] = useState({ label: 'Select Approver', value: '' });

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    
    const [bankCashes, setBankCashes] = useState([]);
    const [bankCash, setBankCash] = useState({ label: 'Select Bank Cash', value: '' });

    const [ledgers, setLedgers] = useState([]);
    const [ledger, setLedger] = useState({ label: 'Select Expense Ledger', value: '' });

    const [formData, setFormData] = useState<FormData>({
        expenseAmount: '',
        taAmount: '',
        daAmount: '',
        otherAmount: '',
        expenseDate: '',
        expenseCategory: '',
        idUsers: currentUser?.id_roles === 1 ? currentUser?.id : '',
        idApprover: '',
        idProjects: '',
        transactionType: 'bank_account',
        idBankCash: '',
        idAccLedgers: '',
        remarks: '',
        status: actionChannel,
    });

    const [file, setFile] = useState<File | null>(null);

    useEffect(() => {
        getExpenseCategory();
        setFormData({
            expenseAmount: '',
            taAmount: '',
            daAmount: '',
            otherAmount: '',
            expenseDate: '',
            expenseCategory: '',
            idUsers: currentUser?.id_roles === 1 ? currentUser?.id : '',
            idApprover: '',
            idProjects: '',
            transactionType: 'bank_account',
            idBankCash: '',
            idAccLedgers: '',
            remarks: '',
            status: actionChannel,
        })
        setFile(null);
    }, [id]);

    // Auto-calculate total amount whenever TA, DA, or Other amounts change
    useEffect(() => {
        const ta = parseFloat(formData.taAmount) || 0;
        const da = parseFloat(formData.daAmount) || 0;
        const others = parseFloat(formData.otherAmount) || 0;
        const total = ta + da + others;
        
        if (total !== parseFloat(formData.expenseAmount || '0')) {
            setFormData(prev => ({
                ...prev,
                expenseAmount: total.toFixed(2)
            }));
        }
    }, [formData.taAmount, formData.daAmount, formData.otherAmount]);

    // Update form data when project is auto-selected
    useEffect(() => {
        if (project.value && project.value !== formData.idProjects) {
            setFormData(prev => ({
                ...prev,
                idProjects: project.value
            }));
        }
    }, [project.value, formData.idProjects]);

    useEffect(() => {
        if (currentUser) {
            getUsers();
            getApprovers();
            getProjects();
            getBankCash('bank_account');
            getLedgers();
        }
    }, [currentUser])

    const getExpenseCategory = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'expense/expense-category',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let expenseCategoryObj = resp.data.map((item: any) => {
                    item.label = item.expenseCategory;
                    item.value = item.expenseCategory;
                    return item
                })
                setExpenseCategories(expenseCategoryObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getUsers = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'expense/users',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let userObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setUsers(userObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getApprovers = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'expense/approvers',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let approverObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setApprovers(approverObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
                
                // If there's only one project, automatically select it
                if (projectObj.length === 1) {
                    const singleProject = projectObj[0];
                    setProject(singleProject);
                    setFormData(prev => ({ ...prev, idProjects: singleProject.value }));
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getBankCash = (transactionType: string) => {
        fetch(
            process.env.REACT_APP_API_URL + 'expense/bank-cash/' + transactionType,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let bankCashObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.idBankCash;
                    return item
                })
                setBankCashes(bankCashObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    const getLedgers = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'expense/ledgers',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let ledgerObj = resp.data.map((item: any) => {
                    item.label = item.ledgerName;
                    item.value = item.idAccLedgers;
                    return item
                })
                setLedgers(ledgerObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleExpenseCategoryChange = (expenseCategory: any) => {
        // console.log(expenseCategory, "expenseCategory");
        setExpenseCategory(expenseCategory);
        if (expenseCategory?.label) {
            setFormData({ ...formData, expenseCategory: expenseCategory.label });
            console.log('Selected Expense Category:', expenseCategory.label); // Log the selected category
        } else {
            setFormData({ ...formData, expenseCategory: '' });
        }
    };

    const handleCreateOption = (inputValue: any) => {

        const newOption = { label: inputValue, value: inputValue.toLowerCase() };
        setExpenseCategories(expenseCategories => [...expenseCategories, newOption]);
        setExpenseCategory(newOption);
        setFormData({ ...formData, expenseCategory: inputValue });
    };

    const handleUserChange = (user: any) => {
        setUser(user);
        setFormData({ ...formData, idUsers: user.value });
    }

    // eslint-disable-next-line
    const handleApproverChange = (approver: any) => {
        setApprover(approver);
        setFormData({ ...formData, idApprover: approver.value });
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        //Get Leads by project
        setFormData({ ...formData, idProjects: project.value });
    }

    const transactionTypeChange = (event: any) => {
        const { name, value } = event.target;
        setBankCash({ label: 'Select Bank Cash', value: '' });
        getBankCash(value);
        setFormData({ ...formData, [name]: value });
    };

    const handleBankCashChange = (bankCash: any) => {
        setBankCash(bankCash);
        setFormData({ ...formData, idBankCash: bankCash.value });
    }

    const handleLedgerChange = (ledger: any) => {
        setLedger(ledger);
        setFormData({ ...formData, idAccLedgers: ledger.value });
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        
        // If TA, DA, Others change, recalculate expenseAmount
        if (["taAmount", "daAmount", "otherAmount"].includes(name)) {
            const newForm = { ...formData, [name]: value };
            const ta = parseFloat(newForm.taAmount) || 0;
            const da = parseFloat(newForm.daAmount) || 0;
            const others = parseFloat(newForm.otherAmount) || 0;
            const total = ta + da + others;
            newForm.expenseAmount = total.toFixed(2);
            setFormData(newForm);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    };

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);
      
        try {
            const formPayload = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                formPayload.append(key, value);
            });
            
            if (file) {
                formPayload.append('file', file);
            }
            
            const response = await fetch(process.env.REACT_APP_API_URL + 'expense/store', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + jwt(),
                },
                body: formPayload,
            });

            const data = await response.json();

            if (data.success) {
                toast(<strong>Expense created successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                setFormData({
                    expenseAmount: '',
                    taAmount: '',
                    daAmount: '',
                    otherAmount: '',
                    expenseDate: '',
                    expenseCategory: '',
                    idUsers: currentUser?.id_roles === 1 ? currentUser?.id : '',
                    idApprover: '',
                    idProjects: '',
                    transactionType: 'bank_account',
                    idBankCash: '',
                    idAccLedgers: '',
                    remarks: '',
                });
                setExpenseCategory(null);
                setUser({ label: 'Select Sales Representative', value: '' });
                setApprover({ label: 'Select Approver', value: '' });
                setProject({ label: 'Select Project', value: '' });
                setBankCash({ label: 'Select Bank Cash', value: '' });
                setLedger({ label: 'Select Expense Ledger', value: '' });
                setFile(null);
                handleClose(true);
            } else {
                Swal.close();
                if (data?.errors) {
                    const errorsMessage = validationErrorMsg(data.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Data',
                        html: errorsMessage,
                    })
                }
                if (data?.errorMessage) {
                    toast(data?.errorMessage, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const LedgerSingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
            <>
                <div className='row'>
                    <span> {props.data.label} </span>
                </div>
            </>
        </components.SingleValue>
    )

    const CustomOption = (props) => {
        return (
            <components.Option {...props}>
                <i className="fa fa-file"></i>
                <span> {props.data.label} </span><br />
                {props.data.ledgerPath && (
                    <span><i className="fa fa-map-marker"></i> {props.data.ledgerPath} </span>
                )}
            </components.Option>
        );
    };

    return (<Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Create Expense</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
            <Modal.Body>
                <Form.Group controlId="expenseDate">
                    <Form.Label>Expense Date <span className="required text-danger"></span></Form.Label>
                    <Form.Control
                        type="date"
                        name="expenseDate"
                        value={formData.expenseDate}
                        onChange={handleChange}
                        className='form-control-sm'
                    />
                </Form.Group>

                <div className="row mb-2">
                    <div className="col-md-4">
                        <Form.Group controlId="taAmount">
                            <Form.Label>TA Amount</Form.Label>
                            <Form.Control
                                type="number"
                                name="taAmount"
                                value={formData.taAmount}
                                onChange={handleChange}
                                className='form-control-sm'
                                min={0}
                                step="0.01"
                                placeholder="TA Amount"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-4">
                        <Form.Group controlId="daAmount">
                            <Form.Label>DA Amount</Form.Label>
                            <Form.Control
                                type="number"
                                name="daAmount"
                                value={formData.daAmount}
                                onChange={handleChange}
                                className='form-control-sm'
                                min={0}
                                step="0.01"
                                placeholder="DA Amount"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-4">
                        <Form.Group controlId="otherAmount">
                            <Form.Label>Others Amount</Form.Label>
                            <Form.Control
                                type="number"
                                name="otherAmount"
                                value={formData.otherAmount}
                                onChange={handleChange}
                                className='form-control-sm'
                                min={0}
                                step="0.01"
                                placeholder="Others Amount"
                            />
                        </Form.Group>
                    </div>
                </div>
                <Form.Group className="mb-3" controlId="expenseAmount">
                    <Form.Label>Total Expense Amount <span className="required text-danger"></span></Form.Label>
                    <Form.Control
                        type="number"
                        name="expenseAmount"
                        value={formData.expenseAmount}
                        className='form-control-sm'
                        min={0}
                        step="0.01"
                        readOnly
                        style={{ background: '#f5f5f5' }}
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="expenseCategory">
                    <Form.Label>Expense Category <span className="required text-danger"></span></Form.Label>
                    <CreatableSelect
                        isClearable
                        isSearchable
                        name="expenseCategory"
                        value={expenseCategory || expenseCategories[0]}
                        onCreateOption={handleCreateOption}
                        onChange={handleExpenseCategoryChange}
                        options={expenseCategories}
                        menuPosition="fixed"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </Form.Group>
                {currentUser?.id_roles === 1 ? (
                    <Form.Group className="mb-3" controlId="user">
                        <Form.Label>Sales Representative</Form.Label>
                        <Form.Control
                            type="text"
                            value={currentUser.fullName}
                            className='form-control-sm'
                            disabled={true}
                        />
                    </Form.Group>
                ) : (
                    <Form.Group className="mb-3" controlId="user">
                        <Form.Label>Select Sales Representative <span className="required text-danger"></span></Form.Label>
                        <Select
                            value={user}
                            onChange={handleUserChange}
                            options={users}
                            menuPosition="fixed"
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </Form.Group>
                )}


                {/* {currentUser?.id_roles === 1 && (
                    <Form.Group className="mb-3" controlId="idApprover">
                        <Form.Label>Select Approver<span className="required text-danger"></span></Form.Label>
                        <Select
                            value={approver}
                            onChange={handleApproverChange}
                            options={approvers}
                            menuPosition="fixed"
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </Form.Group>
                )} */}

                <Form.Group className="mb-3" controlId="project">
                    <Form.Label>Project <span className="required text-danger"></span></Form.Label>
                    <Select
                        value={project}
                        onChange={handleProjectChange}
                        options={projects}
                        menuPosition="fixed"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </Form.Group>
            
                {actionChannel === 'paid' && (
                    <>
                        <Form.Group className="mb-3" controlId="transactionType">
                            <Form.Label>Mode of Transaction</Form.Label>
                            <select className="form-select form-select-sm"
                                name='transactionType'
                                value={formData.transactionType}
                                onChange={transactionTypeChange}
                            >
                                <option value="bank_account">Bank</option>
                                <option value="cash_box">Cash</option>
                                <option value="mobile_wallet">Mobile Wallet</option>
                            </select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="lead">
                            <Form.Label>Select Bank/Cash <span className="required text-danger"></span></Form.Label>
                            <Select
                                value={bankCash}
                                onChange={handleBankCashChange}
                                options={bankCashes}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="lead">
                            <Form.Label>Select Expense Ledger<span className="required text-danger"></span></Form.Label>
                            <Select
                                value={ledger}
                                onChange={handleLedgerChange}
                                options={ledgers}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                components={{ SingleValue: LedgerSingleValue, Option: CustomOption }}
                            />
                        </Form.Group>
                    </>
                )}


                <Form.Group className="mb-3" controlId="remarks">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control as="textarea" rows={3} name="remarks" value={formData.remarks} onChange={handleChange} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="file">
                    <Form.Label>Upload File</Form.Label>
                    <Form.Control type="file" onChange={handleFileChange} />
                    {file && <div className="mt-1"><small>Selected: {file.name}</small></div>}
                </Form.Group>

            </Modal.Body>
            <Modal.Footer>

                <button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
                    {loading &&
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    }
                    <span>  Submit</span>
                </button>
                <Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Form>
    </Modal>)
}

export default ExpenseCreate